import React from 'react';
import './CareersFeaturedEmployees.scss';
import Slider from 'react-slick';
import { renderSlides } from './util/renderSlides';
import Button from '../../@redantler/redantler-npm-button-react';
import { COLORS } from '../../../constants/colors';
import PrevArrowButton from '../../UI/Icons/PrevArrowButton';
import NextArrowButton from '../../UI/Icons/NextArrowButton';

/**
 * Renders the featured employees slider
 * @param {string} title
 * @param {array} employees
 * @returns {JSX.Element}
 * @constructor
 */
const CareersFeaturedEmployees = ({ title, employees }) => {
  const settings = {
    dots: false,
    infinite: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: (
      <Button addClass="c-careers-featured-employees__arrow c-careers-featured-employees__prev">
        <PrevArrowButton color={COLORS.black} />
      </Button>
    ),
    nextArrow: (
      <Button addClass="c-careers-featured-employees__arrow c-careers-featured-employees__next">
        <NextArrowButton color={COLORS.black} />
      </Button>
    ),
  };

  return (
    <div className="c-careers-featured-employees background-color-white">
      <div className="c-careers-featured-employees__inner">
        <div className="c-careers-featured-employees__title h2-roobert color-black">
          <h2>{title}</h2>
        </div>
        <div className="c-careers-featured-employees__slides">
          <Slider {...settings}>{renderSlides(employees)}</Slider>
        </div>
      </div>
    </div>
  );
};

export default CareersFeaturedEmployees;
